import React from 'react'
import Button from '@mui/material/Button'
import './Option.scss'

function Option(props) {
    const style = {
        textAlign: 'left',
        border: "1px solid lightgrey",
        borderRadius: "2px",
        padding: "6px",
        marginBottom: "6px",
        transition: "background-color 0.2s ease",
        color: props.isSelected ? 'white' : 'black',
        backgroundColor: props.isSelected ? '#B2292D' : '#E7DCDA',
        '&:hover': {backgroundColor: '#B2292D', color: 'white'},
        width: "100%",
        textTransform: 'none',
        display: 'flex',
        fontWeight: props.isSelected ? 'bold' : '500',
        fontFamily: 'Montserrat',
    }

    return (
        <Button
            sx={style}
            onClick={() => props.handleClick(props.index)}
            disabled={props.responseSubmitted}
        >
        <p>{props.option.content}</p>
        </Button>
    )
}

export default Option